import { render, staticRenderFns } from "./VideoInfoPaywall.vue?vue&type=template&id=4663295d&scoped=true"
import script from "./VideoInfoPaywall.vue?vue&type=script&lang=js"
export * from "./VideoInfoPaywall.vue?vue&type=script&lang=js"
import style0 from "./VideoInfoPaywall.vue?vue&type=style&index=0&id=4663295d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4663295d",
  null
  
)

export default component.exports